import { useState } from 'react';
import { InputGroup, Button, Form } from 'react-bootstrap';
import { userService } from '../../../services/userService';
import Required from '../../../utils/Required';

const UsernameAvailabilityField = ({ formData, onChange }) => {
  const [checked, setChecked] = useState(false);
  const [available, setAvailable] = useState(false);
  const [checking, setChecking] = useState(false);

  const check = async () => {
    setChecking(true);
    const res = await userService.checkUsername(formData.username);
    setAvailable(res.available);
    setChecked(true);
    setChecking(false);
  };

  return (
    <Form.Group className="mb-3">
      <InputGroup className="mb-0">
        <Form.FloatingLabel label={<Required>Username</Required>} controlId="username">
        <Form.Control
        name="username"
        value={formData.username}
        onChange={e => {
            onChange(e);
            setChecked(false);
        }}
        onBlur={check}
        isValid={checked && available}
        isInvalid={checked && !available}
        autoComplete="off"
        required
        />
        </Form.FloatingLabel>

        <Button
          variant="outline-secondary"
          onClick={check}
          disabled={checking || !formData.username}
          className={`rounded-start-0 ${checked && !available? 'bg-danger-subtle border-danger': ''}`}
        >{checking ? '...' : 'Check'}</Button>
      </InputGroup>
      {checked && available && (
      <Form.Text className="text-success">Username is available.</Form.Text>
      )}
      {checked && !available && (
      <Form.Text className="text-danger">Username is already in use.</Form.Text>
      )}
    </Form.Group>
  );
};

export default UsernameAvailabilityField;
